var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20H14v-6.365c0-2.006-1.67-2.131-2.005-2.135H4c-.253.002-2.5.08-2.5 2.135V20H0v-6.365C0 10.76 2.617 10 4 10h8c.974 0 3.5.653 3.5 3.635V20zM7.75 1.5c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3m0 7.5a4.505 4.505 0 0 1-4.5-4.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5S10.231 9 7.75 9",
    id: "y2p5fzw9ra"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p3fvogiv4b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y2p5fzw9ra"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#y2p5fzw9ra"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#p3fvogiv4b)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 0h20v20H-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationUser);
export default __webpack_public_path__ + "static/media/navigation-user.96bb021fc47e2ca50da26e4f88b3e4d4.svg";
export { ForwardRef as ReactComponent };